import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'chat',
        component: () => import('../views/Chat')
    },
]

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
